import { render, staticRenderFns } from "./badmintonCupFull_thomasAndUber.vue?vue&type=template&id=7c4a788c"
import script from "./badmintonCupFull_thomasAndUber.vue?vue&type=script&lang=js"
export * from "./badmintonCupFull_thomasAndUber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports